function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.667 16.667c-1.66 0-3.267-.267-4.76-.76a1.337 1.337 0 00-1.354.326l-2.933 2.94a20.08 20.08 0 01-8.787-8.78l2.934-2.946c.366-.367.473-.894.326-1.354-.493-1.493-.76-3.1-.76-4.76C7.333.593 6.74 0 6 0H1.333C.6 0 0 .593 0 1.333 0 13.853 10.147 24 22.667 24c.74 0 1.333-.593 1.333-1.333V18c0-.74-.593-1.333-1.333-1.333z",
  fill: "#fff"
});

var SvgContact = function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgContact;